module.exports = __webpack_public_path__ + "img/dialog-license.4f8c4ef4.png";